var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49972 0.916687C11.4117 0.916687 14.5831 4.088 14.5831 8.00003C14.5831 11.912 11.4117 15.0834 7.49972 15.0834C3.5877 15.0834 0.416382 11.912 0.416382 8.00003C0.416382 4.088 3.5877 0.916687 7.49972 0.916687ZM7.49972 1.97919C4.1745 1.97919 1.47888 4.67481 1.47888 8.00003C1.47888 11.3252 4.1745 14.0209 7.49972 14.0209C10.8249 14.0209 13.5206 11.3252 13.5206 8.00003C13.5206 4.67481 10.8249 1.97919 7.49972 1.97919ZM6.6143 9.01953L9.78034 5.85354C9.98781 5.64608 10.3241 5.64608 10.5316 5.85354C10.7202 6.04215 10.7374 6.33728 10.583 6.54526L10.5316 6.60482L6.98993 10.1465C6.80137 10.3351 6.50621 10.3523 6.29824 10.1979L6.23867 10.1465L4.46782 8.37566C4.26035 8.16818 4.26035 7.83187 4.46782 7.6244C4.65643 7.43577 4.95156 7.41863 5.15953 7.57297L5.21912 7.6244L6.6143 9.01953L9.78034 5.85354L6.6143 9.01953Z",
    fill: "#35BF75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneOrder);
export default __webpack_public_path__ + "static/media/done_order.2ae51f185ed59a26266f0f41a2b210d7.svg";
export { ForwardRef as ReactComponent };